
import './ModalMenu.css'
import { IoClose } from 'react-icons/io5';
import { AiOutlineHistory } from "react-icons/ai";
import { useState, useEffect } from 'react';
import GoogleAutocomplete from '../driveComponents/GoogleAutocomplete';
import { useLoadScript } from '@react-google-maps/api';
import ModalPartners from './ModalPartners';
import ModalPromo from './ModalPromo';


const api_key = process.env.REACT_APP_GOOGLE_KEY;
const places = ["places"]

const ModalMenu = ({setShowModalMenu, state}) => {
    const orders = state.orders // Dnešní a včerejší
    const [showHistory, setShowHistory] = useState(false)
    const [start, setStart] = useState("")
    const [end, setEnd] = useState("")
    const [tel, setTel] = useState("")
    const [note, setNote] = useState("")
 
    const [sendForm, setSendForm] = useState(false)
    
    // Parner modal
    const [showPartners, setShowPartners] = useState(false)

    // Promo modal
    const [showPromo, setShowPromo] = useState(false)

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: api_key,
        libraries: places,
    })
  



    // získat historii
    const getHistoryOfOrder = () => {
        setShowModalMenu(false)
    }

    // Vložit ručně objednávku
    const saveHandleOrder = () => {
        if(start && end && !sendForm){
            setSendForm(true)
            fetch(state.server + "api2/reciveDriverHandMadeOrder.php", {
                method: 'POST',
                body: JSON.stringify({
                adresStart: start.adres, 
                adresDest: end.adres,
                lat: start.gps.lat, 
                lng: start.gps.lng, 
                tokenOfDriver: state.tokenOfDriver, 
                desLat: end.gps.lat, 
                desLng: end.gps.lng, 
                tel: tel,
                note: note
                })
            })
            .then( (res)=>  res.json() )
            .then( (response) => {

                if(response.status === "OK"){

                    setShowModalMenu(false)
                    window.location.reload();
                        
                } else {
                        alert("Chyba systému")
                }
            })
        } else {
            alert("Vyplňte Start a Cíl")
        } 
    }


    // HISTORY MODAL
    if(showHistory) {
        return (
            <div className='ModalMenuContainer'>
                <IoClose size={30} color={"grey"} className="closeIcon" onClick={()=>setShowModalMenu(false)}/>
                <div className='ListOfHistory'>
                    <div className="titleOfModal" onClick={getHistoryOfOrder}>
                        <h3>Dnešní historie</h3>
                    </div>

                    <div className="content">
                        {orders.map( (one => {
                            return (
                                <div className='oneRowOfHistory' key={one.id}>
                                    <h3>{one.date}</h3>
                                    <p>Start: {one.start}</p>
                                    <p>Cíl: {one.destination}</p>
                                    <p>Tel: {one.tel}</p>
                                    <a href={"tel:"+ one.tel}>{one.tel}</a>
                                    <p>Vzdálenost: {one.tripDistance} m</p>
                                </div>
                            )
                        }))}
                       
                    </div>
                </div>
            </div>
            )
    }

        // PARTNERS MODAL
        if(showPartners) {
            return <ModalPartners state={state} setShowModalMenu={setShowModalMenu}/>
        }

        // PROMO MODAL
        if(showPromo) {
            return <ModalPromo state={state} setShowModalMenu={setShowModalMenu}/>
        }
    

        // VYBER MODALU
        return (
        <div className='ModalMenuContainer'>
       
            <IoClose size={30} color={"grey"} className="closeIcon" onClick={()=>setShowModalMenu(false)}/>
            <div className="titleOfModal">
                <h3>Menu</h3>
            </div>
  
            <section className='listOfIcons'>
                <div onClick={()=>setShowHistory(true)}> 
                    <AiOutlineHistory/> 
                    <p>Historie</p>
                </div>
                <div onClick={()=>setShowPartners(true)}> 
                    <p>Partner</p>
                </div>
                <div onClick={()=>setShowPromo(true)}> 
                    <p>Promo</p>
                </div>
            </section>

              
            <section className='handInputFromDriver'>
                <label htmlFor="">Start:</label>
                <GoogleAutocomplete  outputFromGoogle={setStart} />
                <label htmlFor="">Cíl:</label>
                <GoogleAutocomplete  outputFromGoogle={setEnd} />
                <label htmlFor="">Tel:</label>
                <input type="text" placeholder='Telefon klienta' className='inputUserTel' value={tel} onChange={ (e)=> setTel(e.target.value)}/>
                <label htmlFor="">Poznámka:</label>
                <input type="text"  className='inputUserTel' value={note} onChange={ (e)=> setNote(e.target.value)}/>
                <br />
                {!sendForm && <button className='handInsertOrderBtn' onClick={saveHandleOrder}>Vložit objednávku</button> }
            </section>
        </div>
        )
}

export default ModalMenu